export const InStock = () => {
  return (
    <svg width="1.5em" height="1.5em" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="m23 12l-2.4-2.8l.3-3.7l-3.6-.8l-1.9-3.2L12 3L8.6 1.5L6.7 4.7l-3.6.8l.3 3.7L1 12l2.4 2.8l-.3 3.7l3.6.8l1.9 3.2L12 21l3.4 1.5l1.9-3.2l3.6-.8l-.3-3.7L23 12m-4.3 4.9l-2.7.6l-1.4 2.4l-2.6-1.1l-2.6 1.1L8 17.5l-2.7-.6l.2-2.8L3.7 12l1.8-2.1l-.2-2.8L8 6.5l1.4-2.4L12 5.2l2.6-1.1L16 6.5l2.7.6l-.2 2.8l1.8 2.1l-1.8 2.1l.2 2.8m-2.1-9.3L18 9l-8 8l-4-4l1.4-1.4l2.6 2.6l6.6-6.6Z"
      ></path>
    </svg>
  );
};
